/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-notifications-edit-view-component.ts
 *
 * Created by randysorensen on 4/11/18.
 */

function PackageNotificationsEditViewController(this: JS5Object,
                                                _: JS5Object,
                                                $timeout: JS5Function,
                                                PackageNotificationsService: JS5Object,
                                                SidebarService: JS5Object,
                                                BreadcrumbService: JS5Object) {

    const getData = () => {
        this.loadingIndicator.show = true;
        return PackageNotificationsService.getPackageNotificationEditData()
            .then((editData: JS5Object) => {
                this.availableEmailTemplates = editData.emailTemplates;
                this.availablePackageStatuses = editData.availablePackageStatuses;
                this.notification = editData.packageNotification;
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const requiredFieldsArePopulated = () => {
        const statusIsPopulated = _.get(this, 'notification.status.length') > 0;
        const delayIsPositive = _.get(this, 'notification.delay') >= 0;
        const emailTemplateIsSelected = !_.isNil(_.get(this, 'notification.emailTemplate'));
        return statusIsPopulated && delayIsPositive && emailTemplateIsSelected;
    };

    const saveNotification = () => {
        this.loadingIndicator.show = true;
        PackageNotificationsService.saveEditData()
            .then((savedNotification: JS5Object) => {
                this.notification = savedNotification;
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };

    const revertNotification = () => {
        this.notification = PackageNotificationsService.revertEditData();
    };

    const initToolbar = () => {
        this.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: () => this.editorForm.$dirty && requiredFieldsArePopulated(),
                onClick: saveNotification
            },
            {
                label: 'Revert',
                enabled: () => PackageNotificationsService.canRevertEditView(),
                onClick: revertNotification
            },
            {
                label: 'Close',
                enabled: () => true,
                onClick: () => PackageNotificationsService.exitEdit()
            }];
    };

    this.$onInit = () => {
        this.notification = {};

        this.availableEmailTemplates = <JS5Object>[];
        this.availablePackageStatuses = <JS5Object>[];
        this.breadcrumbName = 'Edit Package Status Notification';
        this.toolbarButtonDefs = undefined;

        BreadcrumbService.editService = PackageNotificationsService;
        SidebarService.editService = PackageNotificationsService;

        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        initToolbar();

        getData();
    };

    this.$postLink = () => {
        $timeout(() => {
            PackageNotificationsService.editorForm = this.editorForm;
        });
    };

}

angular.module('prism-ui.packageNotifications').component(
    'packageNotificationsEditView', {
        controller: PackageNotificationsEditViewController,
        templateUrl: 'system/packageNotifications/editView/package-notifications-edit-view-template.html',
        bindings: {}
    });
